<div class="container add-menu-page">
    <div class="add-menu-page__header">
        <h2 class="add-menu-page__title">Add Menu Card Items</h2>
    </div>

    <div class="add-menu-card">
        <div class="add-menu">
            <div class="add-menu__tabs-section">
                <div class="add-menu__tabs" role="tablist">
                    <button type="button" class="menu-tab" *ngFor="let tab of scenarioTabs" role="tab"
                        [class.menu-tab--active]="activeScenarioId === tab.scenarioId"
                        [attr.aria-selected]="activeScenarioId === tab.scenarioId"
                        (click)="selectScenario(tab.scenarioId)">
                        <span class="menu-tab__content">
                            <mat-icon class="menu-tab__icon">{{ tab.icon }}</mat-icon>
                            <span class="menu-tab__label-en">{{ tab.scenarioName }}</span>
                        </span>
                    </button>
                </div>

                <div class="add-menu__search-row">
                    <div class="add-menu__search-wrap">
                        <mat-icon class="add-menu__search-icon">search</mat-icon>
                        <input type="text" class="add-menu__search" [(ngModel)]="searchText" placeholder="Search items..."
                            aria-label="Search items" />
                    </div>
                    <button type="button" class="add-menu__toggle-btn" (click)="toggleAddMissingForm()">
                        + Add to menu
                    </button>
                </div>

                <div class="add-menu__missing-form" *ngIf="showAddMissingForm">
                    <div class="add-menu__missing-field">
                        <label class="add-menu__missing-label" for="missing-item-en">English</label>
                        <input id="missing-item-en" type="text" class="add-menu__missing-input" [(ngModel)]="newItemName"
                            placeholder="Enter menu item in English" aria-label="Menu item name in English"
                            (ngModelChange)="onNewItemNameChange()"
                            (keydown.enter)="confirmAddMissingItem()" />
                    </div>
                    <div class="add-menu__missing-field">
                        <label class="add-menu__missing-label" for="missing-item-te">Telugu</label>
                        <input id="missing-item-te" type="text"
                            class="add-menu__missing-input add-menu__missing-input--readonly"
                            [ngModel]="newItemNameTe"
                            placeholder="Telugu preview"
                            aria-label="Menu item name in Telugu"
                            readonly />
                    </div>
                    <p class="add-menu__duplicate-error" *ngIf="duplicateError">{{ duplicateError }}</p>
                    <div class="add-menu__missing-actions">
                        <button type="button" class="add-menu__btn add-menu__btn--ghost" (click)="cancelAddMissing()">
                            Cancel
                        </button>
                        <button type="button" class="add-menu__btn add-menu__btn--primary" (click)="confirmAddMissingItem()">
                            Add to Menu
                        </button>
                    </div>
                </div>
            </div>

            <div class="add-menu__body">
                <div class="menu-section__head">
                    <span class="menu-section__title">Available Menu</span>
                    <span class="menu-section__count">{{ availableItems.length }}</span>
                </div>

                <div class="menu-item" *ngFor="let item of availableItems">
                    <div class="menu-item__text">
                        <div class="menu-item__name-en">{{ item.itemNameEn }}</div>
                        <div class="menu-item__name-te" *ngIf="item.itemNameTe">{{ item.itemNameTe }}</div>
                    </div>
                </div>

                <div class="add-menu__empty" *ngIf="!availableItems.length">
                    No menu items found.
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
